export const remapServerData = (data) => ({
  ...data,
  locations: data.locations?.map((location) => ({
    ...location,
    iso_code: location.iso_code === 'uk' ? 'GB' : location.iso_code.toUpperCase(), // updating wrong iso retrieved from backend + uppercasing for i18n-iso-countries
  })),
  locationCount: data.locations?.length,
});
